// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a8638ee3","453":"539f4886","732":"85fb0c91","977":"c2da4c26"}[chunkId] + ".chunk.js";
};